<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Blog'}">
              <h4 class="ms-2">
                {{label.pages.blogs}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-row>
            <b-col cols="5" class="align-self-center py-0">
              <b-row class="my-4" v-show="contentLanguageAccess == 1">
                <b-col class="align-self-center" cols="4">
                  <label for="language" class="ps_label">
                    {{label.pages.contentLanguage}}
                    <span class="ps_label_star">*</span>
                  </label>
                </b-col>
                <b-col class="align-self-center" cols="8">
                  <v-select
                      input-id="language"
                      :options="languages"
                      v-model="selectedLanguage"
                      :reduce="group => group.id"
                      :clearable="false"
                      size="sm"
                      class="ps_select"
                      @input="setLanguage"
                  >
                  </v-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col :cols="contentLanguageAccess == 1 ? '7' : '12'">
              <b-row class="mt-4 mb-3">
                <b-col class="text-start" cols="4">
                  <label for="categories" class="ps_label">
                    {{label.pages.category}}
                    <span class="ps_label_star">*</span>
                  </label>
                </b-col>
                <b-col cols="8" class="align-self-center" dir="rtl">
                  <treeselect
                      id="categories"
                      :options="categories"
                      :placeholder="label.pages.search"
                      v-model="form.categories"
                      :normalizer="normalizer"
                      :flat="true"
                      multiple
                      :default-expand-level="5"
                  ></treeselect>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="8">
              <b-row class="my-4">
                <b-col class="align-self-center" cols="2">
                  <label for="title" class="ps_label">
                    {{label.form.blogTitle}}
                    <span class="ps_label_star">*</span>
                  </label>
                </b-col>
                <b-col class="align-self-center" cols="10">
                  <b-form-input id="title" size="md" v-model="form.title"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <b-row class="my-4">
                <b-col cols="4" class="text-start">
                  <label for="priority" class="ps_label">
                    {{label.form.priority}}
                  </label>
                </b-col>
                <b-col cols="8">
                  <b-form-input
                    type="number"
                    id="priority"
                    v-model="form.priority"
                    class="text-center"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <b-row v-if="dropZoneAction" class="my-4">
                <b-col>
                  <drop-zone-custom
                      mode="image"
                      :isRequired="true"
                      :add="dropZoneAction"
                      :edit="!dropZoneAction"
                      :editSrc="imageAddress"
                  />
                </b-col>
              </b-row>
              <b-row v-if="!dropZoneAction" class="my-4">
                <b-col sm="12">
                  <drop-zone-custom
                      mode="image"
                      :isRequired="true"
                      :add="dropZoneAction"
                      :edit="!dropZoneAction"
                      :editSrc="imageAddress"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <b-row v-if="dropZoneAction2" class="my-4">
                <b-col>
                  <drop-zone-custom
                      mode="video"
                      :isRequired="true"
                      :add="dropZoneAction2"
                      :edit="!dropZoneAction2"
                      :editSrc="videoAddress"
                  />
                </b-col>
              </b-row>
              <b-row v-if="!dropZoneAction2" class="my-4">
                <b-col sm="12">
                  <drop-zone-custom
                      mode="video"
                      :isRequired="true"
                      :add="dropZoneAction2"
                      :edit="!dropZoneAction2"
                      :editSrc="videoAddress"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <b-row v-if="dropZoneAction3" class="my-4">
                <b-col>
                  <drop-zone-custom
                      mode="file"
                      :isRequired="true"
                      :add="dropZoneAction3"
                      :edit="!dropZoneAction3"
                      :editSrc="fileAddress"
                      :extension="fileExtension"
                  />
                </b-col>
              </b-row>
              <b-row v-if="!dropZoneAction3" class="my-4">
                <b-col sm="12">
                  <drop-zone-custom
                      mode="file"
                      :isRequired="true"
                      :add="dropZoneAction3"
                      :edit="!dropZoneAction3"
                      :editSrc="fileAddress"
                      :extension="fileExtension"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <b-row class="mt-4 mb-3">
                <b-col class="align-self-center" cols="4">
                  <label for="gallery" class="ps_label">
                    {{label.pages.gallery}}
                  </label>
                </b-col>
                <b-col cols="8" class="align-self-center" dir="rtl">
                  <treeselect
                      id="gallery"
                      :options="galleryTypeOption"
                      :placeholder="label.pages.searchTitle"
                      v-model="galleryType"
                      :normalizer="normalizer"
                      @input="loadAlbum"
                  ></treeselect>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <b-row class="mt-4 mb-3">
                <b-col class="align-self-center" cols="4">
                  <label for="album" class="ps_label">
                    {{label.pages.album}}
                  </label>
                </b-col>
                <b-col cols="8" class="align-self-center" dir="rtl">
                  <treeselect
                      id="album"
                      :options="galleryOption"
                      :placeholder="label.pages.searchTitle"
                      v-model="form.galleryId"
                      :normalizer="normalizer2"
                      :noOptionsText="label.pages.chooseGallery"
                  ></treeselect>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6" class="align-self-center py-0">
              <b-row class="my-4">
                <b-col class="align-self-center" cols="4">
                  <label for="headline" class="ps_label">
                    {{label.pages.headline}}
                  </label>
                </b-col>
                <b-col class="align-self-center" cols="8">
                  <b-form-input id="headline" size="md" v-model="form.headline"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="3" class="align-self-center py-0">
              <b-row class="my-4">
                <b-col class="text-start" cols="4">
                  <label for="source" class="ps_label">
                    {{label.pages.source}}
                  </label>
                </b-col>
                <b-col class="align-self-center" cols="8">
                  <b-form-input id="source" size="md" v-model="form.source"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="3" class="align-self-center py-0">
              <b-row class="my-4">
                <b-col class="text-start" cols="4">
                  <label for="writer" class="ps_label">
                    {{label.pages.writer}}
                  </label>
                </b-col>
                <b-col class="align-self-center" cols="8">
                  <b-form-input id="writer" size="md" v-model="form.writer"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row class="my-4">
                <b-col cols="2">
                  <label for="shortDescription" class="ps_label">
                    {{label.pages.summary}}
                    <span class="ps_label_star">*</span>
                    <b-icon
                        icon="question-circle-fill"
                        scale="1.2"
                        variant="ps-base"
                        class="me-1 mouse-question"
                        id="blogShortDescGuide"
                    />
                    <b-popover
                      boundary="#app"
                      placement="top"
                      noninteractive
                      triggers="hover"
                      target="blogShortDescGuide"
                      dir="rtl"
                    >
                      {{ label.pages.Description }}
                    </b-popover>
                  </label>
                </b-col>
                <b-col cols="10">
                  <b-form-textarea
                    id="shortDescription"
                    size="sm"
                    rows="2"
                    v-model="form.shortDescription"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="9">
              <b-row class="my-4">
                <b-col cols="2">
                  <label for="tags" class="ps_label">
                    {{label.form.tags}}
                    <b-icon
                        icon="question-circle-fill"
                        scale="1.2"
                        variant="ps-base"
                        class="me-1 mouse-question"
                        id="blogTagsGuide"
                    />
                    <b-popover
                      boundary="#app"
                      placement="top"
                      noninteractive
                      triggers="hover"
                      target="blogTagsGuide"
                      dir="rtl"
                    >
                      {{ label.guide.productTags }}
                    </b-popover>
                  </label>
                </b-col>
                <b-col cols="10">
                  <v-select
                      id="tags"
                      v-model="form.tags"
                      :closeOnSelect="false"
                      size="sm"
                      taggable
                      multiple
                      class="ps_select">
                    <template #no-options>
                      {{label.pages.Enter}}
                    </template>
                  </v-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="3">
              <b-row class="my-4">
                <b-col class="text-start">
                  <label for="display" class="ps_label">
                    {{label.form.display}}
                  </label>
                </b-col>
                <b-col>
                  <label class="ps-switch">
                    <input id="display" type="checkbox" v-model="form.isConfirm">
                    <span class="slider round"></span>
                  </label>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row class="my-4">
                <b-col cols="12">
                  <label for="code" class="ps_label">
                    {{label.form.blogContent}}
                    <span class="ps_label_star">*</span>
                  </label>
                  <DxHtmlEditor v-model="form.text" :height="editorHeight" >
                    <DxMediaResizing :enabled="mediaResize" />
                    <DxImageUpload
                            :tabs="imageUploadType"
                            :file-upload-mode="imageUploadMode"
                    />
                    <DxToolbar :multiline="multilineToolbar">
                      <DxItem :accepted-values="headerValues" name="header" />
                      <DxItem :accepted-values="sizeValues" name="size" />
                      <DxItem :accepted-values="fontValues" name="font" />
                      <DxItem name="separator" />
                      <DxItem
                              v-for="toolbar in editorToolbar"
                              :key="toolbar.id"
                              :name="toolbar.name"
                      />
                    </DxToolbar>
                  </DxHtmlEditor>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card-body>
      <template #footer>
        <div class="d-flex justify-content-end">
          <button
              @click="$router.go(-1)"
              class="ms-2"
              v-b-tooltip.hover
              :title="label.buttons.back"
          >
            <b-icon
                icon="arrow-right-square-fill"
                scale="2.5"
                class="pt-1"
                variant="ps-secondary-icon"
            >
            </b-icon>
          </button>
          <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addPost"
          >
            <b-icon icon="check2-circle" class="ms-1"/>
            {{label.buttons.recordInfo}}
          </b-button>
          <b-button
              v-else
              disabled
              variant="ps-success"
              size="sm"
              class="mx-1"
          >
            <b-spinner small></b-spinner>
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { devExtremeEditor } from "@/components/textEditor/devExtremeEditor";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import dropZoneCustom from '@/components/DropZoneCustom'
import alert from '@/plugins/AlertMessages.js'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: 'AddBlog',
  mixins: [devExtremeEditor, contentLanguage],
  components: {
    Treeselect,
    dropZoneCustom
  },
  data() {
    return {
      label,
      normalizer(node) {
        return {
          id: node.id,
          label: node.text,
          children: node.children,
        }
      },
      normalizer2(node) {
        return {
          id: node.id,
          label: node.galleryTitle,
        }
      },
      form: {
        fileExtension: null,
        imageName: null,
        videoName: null,
        fileName: null,
        galleryId: null,
        shortDescription: '',
        text: '',
        title: '',
        headline: '',
        source: '',
        writer: '',
        priority: null,
        video: null,
        image: null,
        file: null,
        categories: [],
        tags: [],
        isConfirm: true,
      },
      refreshImage: true,
      refreshVideo: true,
      refreshFile: true,
      imageAddress: null,
      videoAddress: null,
      fileAddress: null,
      fileExtension: null,
      dropZoneAction: true,
      dropZoneAction2: true,
      dropZoneAction3: true,
      galleryType: null,
      galleryTypeOption: [
        {
          id: 1,
          text: "عکس",
        },
        {
          id: 2,
          text: "فیلم",
        },
        {
          id: 3,
          text: "صوت",
        },
      ],
      galleryOption: null,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      categories: 'baseX/categoryChilds',
      images: 'baseX/images',
      videos: 'baseX/videos',
      sounds: 'baseX/sounds',
      loadingBtn: 'loadingBtn',
      imageUrl: 'imageUrl',
      videoUrl: 'videoUrl',
      fileUrl: 'fileUrl',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.$router.push({name: 'Blog'})
      }
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.refreshImage = false
        this.dropZoneAction = false
        this.form.imageName = this.imageUrl[0].fullPath
        this.imageAddress = this.imageUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshImage = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
    videoUrl() {
      if (this.videoUrl && this.videoUrl.length > 0) {
        this.refreshVideo = false
        this.dropZoneAction2 = false
        this.form.videoName = this.videoUrl[0].fullPath
        this.videoAddress = this.videoUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshVideo = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
    fileUrl() {
      if (this.fileUrl && this.fileUrl.length > 0) {
        this.refreshFile = false
        this.dropZoneAction3 = false
        this.form.fileName = this.fileUrl[0].fullPath
        this.fileAddress = this.fileUrl[0].fileAddress
        this.fileExtension = this.fileUrl[0].extension
        this.$nextTick(() => {
          this.refreshFile = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
    images() {
      this.galleryOption = this.images
    },
    videos() {
      this.galleryOption = this.videos
    },
    sounds() {
      this.galleryOption = this.sounds
    },
  },
  methods: {
    addPost() {
      this.$store.commit("setLoadingBtn", true);
      let formData = new FormData();
      // languageeee
      formData.append('languageId', this.selectedLanguage);
      if (this.form.shortDescription != null) {
        formData.append('ShortDescription', this.form.shortDescription);
      }
      if (this.form.text != null) {
        formData.append('Text', this.form.text);
      }
      if (this.form.title != null) {
        formData.append('Title', this.form.title);
      }
      formData.append('Headline', this.form.headline);
      formData.append('Source', this.form.source);
      formData.append('Writer', this.form.writer);
      if (this.form.priority != null) {
        formData.append('Priority', this.form.priority);
      }
      if (this.form.videoName != null) {
        formData.append('VideoName', this.form.videoName);
      }
      if (this.form.imageName != null) {
        formData.append('ImageName', this.form.imageName);
      }
      if (this.form.fileName != null) {
        formData.append('FileName', this.form.fileName);
      }
      if (this.form.galleryId != null) {
        formData.append('GalleryId', this.form.galleryId);
      }
      if (this.form.categories != null) {
        for (let i = 0; this.form.categories.length > i; i) {
          formData.append('Categories', this.form.categories[i]);
          i++;
        }
      }
      if (this.form.tags != null) {
        for (let i = 0; this.form.tags.length > i; i) {
          formData.append('Tags', this.form.tags[i]);
          i++;
        }
      }
      formData.append('IsConfirm', this.form.isConfirm);
      if(this.form.title != null && this.form.title !== ''  && this.form.shortDescription != null && this.form.shortDescription !== '' && this.form.text != null && this.form.text !== '' && this.form.categories.length !== 0) {
        this.$store.dispatch('baseX/addPost', formData);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    loadAlbum() {
      if (this.galleryType === 1) {
        this.$store.dispatch('baseX/getImages');
      } else if (this.galleryType === 2) {
        this.$store.dispatch('baseX/getVideos');
      } else {
        this.$store.dispatch('baseX/getSounds');
      }
    },
    getCategories() {
      this.form.categories = [];
      if(this.selectedLanguage === 1){
        this.$store.dispatch('baseX/getCategoryChilds', 1);
      }
      else if(this.selectedLanguage === 2){
        this.$store.dispatch('baseX/getCategoryChilds', 101);
      }
      else if(this.selectedLanguage === 3){
        this.$store.dispatch('baseX/getCategoryChilds', 201);
      }
      else if(this.selectedLanguage === 4){
        this.$store.dispatch('baseX/getCategoryChilds', 301);
      }
      else if(this.selectedLanguage === 5){
        this.$store.dispatch('baseX/getCategoryChilds', 401);
      }
    },
    reloadContent(){
      this.getCategories();
    },
  },
  mounted() {
    this.getCategories();
  }
}
</script>
